module.exports = __webpack_public_path__ + "img/Pic-mzd.1cfa4487.jpg";